import { useParams } from "react-router-dom";
import { DynamicTestReport } from "@/pages/PublicDynamicTestPage";

/**
 * Shareable public report route (/relatorio-teste/:token) — no login.
 * Reused by the admin "Enviar no WhatsApp" flow so the lead sees the same
 * report generated at the end of /testes/:slug.
 */
export default function PublicTestReportPage() {
  const { token } = useParams();
  return <DynamicTestReport token={token} patientName="" />;
}
